module.exports = __webpack_public_path__ + "static/assets/e5ac690ea3135f785a2221da08fedcfd.png";